{
  "profile": {
    "name": "向阳乔木",
    "domain": "qiaomu.ai",
    "tagline": {
      "zh": "摇滚乐爱好者、AI 创业者和自媒体，永远保持好奇和持续学习的产品经理",
      "en": "Rock music lover, AI entrepreneur, content creator, and product manager who stays curious and keeps learning."
    },
    "bio": {
      "zh": "我关注 AI 产品、创业、自媒体和长期学习。这里是我的个人入口，连接我的写作、项目、社交平台和一些正在生长的想法。",
      "en": "I work around AI products, entrepreneurship, media, and long-term learning. This is my personal gateway to writing, projects, social links, and ideas in motion."
    },
    "email": "vista8@gmail.com"
  },
  "links": [
    { "id": "blog", "label": "Blog", "url": "https://blog.qiaomu.ai", "kind": "writing", "visible": true },
    { "id": "x", "label": "X", "url": "https://x.com/vista8", "kind": "social", "visible": true },
    { "id": "github", "label": "GitHub", "url": "https://github.com/joeseesun/", "kind": "code", "visible": true },
    { "id": "jike", "label": "即刻", "url": "https://web.okjike.com/u/b66a780a-1572-455a-a0db-d601070d4251", "kind": "social", "visible": true },
    { "id": "xiaohongshu", "label": "小红书", "url": "https://www.xiaohongshu.com/user/profile/5ae6916f4eacab18b7523538", "kind": "social", "visible": true },
    { "id": "gmail", "label": "Gmail", "url": "mailto:vista8@gmail.com", "kind": "contact", "visible": true }
  ],
  "posts": {
    "featured": [
      {
        "title": "精选文章待配置",
        "excerpt": "后台可以维护精选文章标题、摘要和链接。",
        "url": "https://blog.qiaomu.ai",
        "date": "2026-05-21"
      }
    ],
    "latest": [
      {
        "title": "最新文章将从博客或后台配置展示",
        "excerpt": "第一版先支持手动配置，后续可接入 RSS 自动同步。",
        "url": "https://blog.qiaomu.ai",
        "date": "2026-05-21"
      }
    ]
  },
  "projects": [
    {
      "id": "github-placeholder",
      "repoUrl": "https://github.com/joeseesun/",
      "name": "GitHub 项目待配置",
      "description": {
        "zh": "在后台填写仓库地址后，系统会尝试读取 GitHub 简介，你也可以手动修改。",
        "en": "Add repository URLs in the admin area. The site can fetch GitHub metadata and let you edit it."
      },
      "language": "GitHub",
      "stars": 0,
      "tags": ["Open Source", "AI"],
      "featured": true,
      "priority": 1
    }
  ],
  "support": {
    "intro": {
      "zh": "如果我的写作、工具或分享对你有帮助，欢迎用赞助或打赏支持持续创作。",
      "en": "If my writing, tools, or sharing help you, sponsorship and tips support the work."
    },
    "buyMeCoffeeUrl": "",
    "qrCodes": [],
    "sponsors": []
  }
}
